module.exports = __webpack_public_path__ + "img/tag_info_dialog.69a23749.png";